/**
 * The static custom request header the API requires on every cookie-authenticated
 * request. It is the CSRF defence: a cross-site HTML form cannot set a custom header,
 * and a cross-origin fetch that tries one triggers a preflight. A request that reaches
 * the API without it is rejected with 403, not 401.
 */
export const CSRF_HEADER_NAME = "X-PIM-CSRF";

/**
 * Headers every request to the API carries. No credential is among them - the session
 * travels in an HttpOnly cookie the browser attaches on its own.
 */
export const buildRequestHeaders = (): Record<string, string> => ({
  [CSRF_HEADER_NAME]: "1",
});
